import { createContext, useContext } from 'react';

/**
 * How a menu hands its close callback to the items inside it.
 *
 * This used to be a prop cloned onto each child. A prop has to survive every
 * wrapper between the menu and the item that consumes it -- withShowable,
 * ProtectedComponent, the ProtectedMenuItem/AllowedMenuItem family -- and each
 * of those spreads what it does not recognise onto MUI's MenuItem, which puts
 * it on the DOM <li> and makes React warn. Guarding by component identity did
 * not hold either: the guard only recognised a bare MUI MenuItem, while most
 * call sites wrap one first.
 *
 * Context reaches the consumer without passing through any of those wrappers,
 * so there is nothing to leak and nothing to keep a list of.
 */
export const CloseMenuContext = createContext<(() => void) | undefined>(
  undefined
);

/** The enclosing menu's close callback, if this item is inside one. */
export const useCloseMenu = () => useContext(CloseMenuContext);
